<template>
  <div class="grid-view__group" v-bind="$attrs">
    <div class="grid-view__group-cell">
      <div class="grid-view__group-value">
        <component
          :is="groupByComponent"
          v-if="groupByComponent"
          :field="field"
          :value="value"
        />
      </div>
      <div v-if="count > 0" class="grid-view__group-count">
        {{ count }}
      </div>
      <!-- Origem Flow: "+ adicionar" por grupo estilo ClickUp, cria linha já
           com o valor do grupo pré-preenchido. -->
      <a
        v-if="canAddRow && fieldIsWritable"
        class="grid-view__group-add-row"
        @click.stop="$emit('add-row-in-group', { groupBy, field, value })"
      >
        <i class="iconoir-plus"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridViewGroup',
  props: {
    groupBy: {
      type: Object,
      required: true,
    },
    allFieldsInTable: {
      type: Array,
      required: true,
    },
    value: {
      type: null,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    canAddRow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['add-row-in-group'],
  computed: {
    field() {
      return this.getField(this.allFieldsInTable, this.groupBy)
    },
    groupByComponent() {
      if (!this.field) {
        return null
      }
      return this.getGroupByComponent(this.field, this)
    },
    fieldIsWritable() {
      if (!this.field) {
        return false
      }
      const fieldType = this.$registry.get('field', this.field.type)
      return fieldType.canWriteFieldValues(this.field)
    },
  },
  methods: {
    getField(allFieldsInTable, groupBy) {
      const field = allFieldsInTable.find((f) => f.id === groupBy.field)
      return field
    },
    getGroupByComponent(field, parent) {
      const fieldType = parent.$registry.get('field', field.type)
      return fieldType.getGroupByComponent(field)
    },
  },
}
</script>
